export default __webpack_public_path__ + "static/media/Teams.094af65c.md";